import { render, staticRenderFns } from "./btn-info.vue?vue&type=template&id=3d8fccd2&scoped=true"
import script from "./btn-info.vue?vue&type=script&lang=js"
export * from "./btn-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8fccd2",
  null
  
)

export default component.exports